export default build =>
    build.query({
        tagTypes: ['allCouponCodes'],
        keepUnusedDataFor: 1,
        query(payload) {
            console.log("in get coupon codes by idddd payload",payload)            
            return {
                url: `/course/getAllCouponCodesByCourse?course_id=${payload.course_id}`,
                method: 'GET',
                //body: payload,
            };
           
        },
       providesTags: ['allCouponCodes']
    })
